
import SweetAlert from 'sweetalert2';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as actions from "store/actions/index";

export const convertObjectToText = (dataObj, printObj = true) => {
    if (dataObj) {
        let data = Object.entries(dataObj);
        return data.reduce((acc, item) => {
            if (typeof (item[0]) !== "object") {
                if (printObj)
                    acc = acc + item[0] + ' = ' + item[1] + "; ";
                else {
                    if (typeof (item[1]) !== "object")
                        acc = acc + item[0] + ' = ' + item[1] + "; ";
                    else if (typeof (item[1]) === "object")
                        acc = acc + item[0] + "; ";
                }
            }
            return acc;
        }, '');
    }
    return null;
}

export const convertArrayObjectToText = (dataObj) => {
    if (dataObj) {
        return dataObj.reduce((acc, item) => {
            acc = acc + '{'
            for (let i in item) {
                acc = acc + `${i}: "${item[i]}", `;
            }
            acc = acc + '}'
            return acc;
        }, '');
    }
    return null;
}

const convertDataForInfo = (infoData, infoCounter, message) => {
    let info = "";
    if (message === "SearchClipByFields") info = convertArrayObjectToText(infoData);
    else if (typeof infoData === 'object') {
        if (message === "SearchClipByFieldsElements" || message === "SearchClipByFieldsStatus") info = convertObjectToText(infoData, false);
        else info = convertObjectToText(infoData);
    } else info = infoData ? infoData : "";

    let currentTime = DataUtil.getCurrentDayTimestamp;

    return { [`${currentTime()} ${infoCounter}.${message}`]: info }
}


export const saveUploadInfo = (dispatch, infoData, infoCounter, message) => {
    dispatch(actions.setCustomUploadInfo(convertDataForInfo(infoData, infoCounter, message)));
}

export const saveSearchInfo = (dispatch, infoData, infoCounter, message) => {
    dispatch(actions.setCustomSearchInfo(convertDataForInfo(infoData, infoCounter, message)));
}

export const showConfirmDialog = (dialogTitle, htmlMsg, language) => {
    let lg = DataUtil.getLanguage(language);
    SweetAlert.fire({
        title: dialogTitle,
        html: htmlMsg,
        showConfirmButton: true,
        confirmButtonColor: CustomTypes.COLOR_RED,
        confirmButtonText: DataUtil.translateMessageForApp("CustomMsgClose", lg)
    });
}

export const showCancelConfirmDialog = (dialogTitle, htmlMsg, language, callback) => {
    let lg = DataUtil.getLanguage(language);
    SweetAlert.fire({
        title: dialogTitle,
        html: htmlMsg,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonColor: CustomTypes.COLOR_BLACK,
        confirmButtonColor: CustomTypes.COLOR_RED,
        cancelButtonText: DataUtil.translateMessageForApp("CustomMsgDelete", lg),
        confirmButtonText: DataUtil.translateMessageForApp("CustomMsgClose", lg)
    }).then(result => {
        if (!result.value) {
            callback();
        }
    });
}

export const showLogFile = (dialogTitle, dataObj, language, callback) => {

    let htmlMsg = "";
    if (dataObj) {
        let data = Object.entries(dataObj);
        let exists = false;
        const elementStyle = '<div style="border:1px solid #f7f7f7; border-top: none; font-size: 12px; color: #aaaaaa; text-align:left; padding: 2px;">';
        const divStyle = '<div style="border-top:1px solid #f7f7f7; max-height: 500px; overflow-y: scroll">';
        const textStyle = '<span style="color: black;">';
        let infos = data.reduce((acc, item) => {
            if (item[0] !== "isLoading" && item[0] !== "clearInfo" && item[0] !== "lastUploadCount" && item[1]) {
                acc = acc + elementStyle + textStyle + DataUtil.writeName(item[0]) + '</span>' + ' : ' + item[1] + '</div>';
                exists = true;
            }

            return acc;
        }, '');

        if (!exists) infos = elementStyle + textStyle + "UploadFileStatus" + '</span>' + ' : ' + "stop" + '</div>';
        htmlMsg = divStyle + infos + '</div>';
    }

    showCancelConfirmDialog(dialogTitle, htmlMsg, language, callback);
}